import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from 'react';

import { useFeature } from 'FeatureProvider';
import { useInventoryModuleAccess } from 'hooks/inventories/useInventoryModuleAccess';
import useUserStore from 'hooks/useUserStore';
import useOrganization from 'hooks/Organization/useOrganization';
import { useAuth } from 'hooks/useAuth';
import history from 'utils/history';

import { MENU_ROUTES } from '../utils/menuMaker/constants';

export function HomeRedirect() {
  const { isAuthenticated } = useAuth();
  const {
    storeState: { selected: storeSelected },
  } = useUserStore();
  const { organization } = useOrganization();
  const usersV3 = (organization as any)?.internalPermissionsSystem || false;

  const superUserAccess = useFeature('adminStore');
  const organizationAccess = useFeature('organizationAccess');
  const menuMakerModuleAccess = useFeature('backofficeModuleMenu');
  const workforceModuleAccess = useFeature('backofficeModuleWorkforce');
  const invoicingModuleAccess = useFeature('backofficeModuleInvoicing');
  const settingsModuleAccess = useFeature('backofficeModuleSettings');
  const reportModuleAccess = useFeature('backofficeModuleReports');
  const inventoryModuleAccess = useFeature('backofficeModuleInventory');
  const subscriptionModuleAccess = useFeature('backofficeModuleSubscriptions');
  const { isModuleEnabled: isInventoryModuleEnabled } = useInventoryModuleAccess();

  const pathDefaultRedirect = () => {
    if (isAuthenticated) {
      if ((superUserAccess || organizationAccess) && storeSelected?.isDraft) return MENU_ROUTES.ROOT;
      if (superUserAccess && reportModuleAccess) return '/reports';
      if (menuMakerModuleAccess) return MENU_ROUTES.ROOT;
      // ✅ Redirect to V3 routes if enabled, otherwise legacy
      if (workforceModuleAccess) return usersV3 ? '/employees' : '/workforce';
      if (invoicingModuleAccess) return '/invoicing';
      if (settingsModuleAccess) return '/settings';
      // /inventories redirects back here when the module is off, so sending the user there would loop.
      if (inventoryModuleAccess && isInventoryModuleEnabled) return '/inventories';
      if (subscriptionModuleAccess) return '/subscriptions';
    }

    if (!isAuthenticated) {
      return '/signin';
    }

    return '/permissions-denied';
  };
  useEffect(() => {
    history.push(pathDefaultRedirect());
  }, [storeSelected]);

  return (
    <Backdrop open>
      <CircularProgress color="secondary" />
    </Backdrop>
  );
}
